import React, { useState } from 'react'
import { Button } from '../Button/Button'
import { ConsentCommentInput } from './ConsentCommentInput'
import { ConsentEvidenceUpload } from './ConsentEvidenceUpload'
import { EvidenceUploadConfig, CommentUploadConfig } from '../../models/Account'
import { useConsentFileUpload } from './useConsentFileUpload'

type ConsentFormBodyProps = {
  evidenceUploadConfig: EvidenceUploadConfig
  commentUploadConfig: CommentUploadConfig
  onSave: (params: { reason?: string; attachmentFileId?: string }) => void
  onCancel: () => void
  isLoading?: boolean
}

export const ConsentFormBody: React.FC<ConsentFormBodyProps> = ({ evidenceUploadConfig, commentUploadConfig, onSave, onCancel, isLoading = false }) => {
  const [comment, setComment] = useState('')
  const { file, setFile, isUploadingFile, uploadFileIfPresent } = useConsentFileUpload()

  const evidenceRequired = evidenceUploadConfig.enabled && evidenceUploadConfig.setting === 'required'
  const commentRequired = commentUploadConfig.enabled && commentUploadConfig.setting === 'required'
  const isSaveDisabled = (evidenceRequired && !file) || (commentRequired && !comment.trim()) || isLoading || isUploadingFile
  const isFileUploading = isLoading || isUploadingFile

  const handleSave = async () => {
    const result = await uploadFileIfPresent()
    if (result === null) return

    onSave({
      reason: comment.trim() || undefined,
      attachmentFileId: result.attachmentFileId,
    })
  }

  return (
    <>
      {evidenceUploadConfig.enabled ? <ConsentEvidenceUpload required={evidenceRequired} file={file} onFileChange={setFile} /> : null}
      {commentUploadConfig.enabled ? <ConsentCommentInput required={commentRequired} value={comment} onChange={setComment} /> : null}

      <div className='d-flex justify-content-end gap-2'>
        <Button variant='secondary' onClick={onCancel} disabled={isFileUploading}>
          Cancel
        </Button>
        <Button variant='primary' onClick={handleSave} disabled={isSaveDisabled} loading={isFileUploading}>
          Save
        </Button>
      </div>
    </>
  )
}
